module.exports = __webpack_public_path__ + "img/partner-new5.4037ea71.png";